<template>
	<ImageFeatureCardShell
		:data="data"
		:editable="editable"
		:active="active"
		:h5="h5"
		@select="$emit('select')"
	/>
</template>

<script>
	import ImageFeatureCardShell from '../shared/ImageFeatureCardShell.vue';
	import { imageBlockEmits, imageBlockProps } from '../shared/imageBlockProps.js';

	export default {
		name: 'GBlockImageFeatureCard',
		components: { ImageFeatureCardShell },
		props: imageBlockProps,
		emits: imageBlockEmits,
	};
</script>
